import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class DeviceContainer extends PureComponent {
  componentDidMount() {
    this.configure();
  }

  componentDidUpdate() {
    this.configure();
  }

  configure() {
    const { ID, type, make, version, userAgent, DNT, configure } = this.props;

    configure({
      ID,
      type,
      make,
      version,
      userAgent,
      DNT,
    });
  }

  render() {
    return this.props.children;
  }
}

DeviceContainer.defaultProps = {
  ID: undefined,
  type: 'not-defined',
  make: 'not-defined',
  version: 'not-defined',
  userAgent: 'not-defined',
  DNT: true,

  children: null,
};

DeviceContainer.propTypes = {
  ID: PropTypes.string,
  type: PropTypes.string,
  make: PropTypes.string,
  version: PropTypes.string,
  userAgent: PropTypes.string,
  DNT: PropTypes.bool,

  configure: PropTypes.func.isRequired,

  children: PropTypes.node,
};

export { DeviceContainer };
